import { Routes } from "@angular/router";
import { roleGuard } from "@kno2/core/session";
import { NetworkIdentityProvidersComponent } from "./network-identity-providers.component";

export const routes: Routes = [
    {
        path: "network/identityprovider",
        component: NetworkIdentityProvidersComponent,
        canActivateChild: [roleGuard],
        data: { roles: ["NetworkAdmin"] },
        children: [
            {
                path: "",
                redirectTo: "",
                pathMatch: "full"
            },
            {
                path: "",
                loadComponent: () => import("./identity-provider/identity-provider.component").then((m) => m.IdentityProviderComponent),
                data: { roles: ["NetworkAdmin"] }
            },
            {
                path: "user-provisioning",
                loadComponent: () => import("./user-provisioning/user-provisioning.component").then((m) => m.UserProvisioningComponent),
                data: { roles: ["NetworkAdmin"] }
            },
            {
                path: "user-groups",
                loadComponent: () => import("./user-groups/user-groups.component").then((m) => m.UserGroupsComponent),
                data: { roles: ["NetworkAdmin"] }
            }
        ]
    }
];
